import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement  } from "./fields.js";

export class DirectorPartingField extends ShadowDOMElement {
    static className = "DirectorPartingField";
    
    static properties = {
		title: {type: String, attribute: "title"},
		textLabel : {title: String, attribute: "text-label"}
    };

    constructor() {
        super();
		this.title = "Directeur";
		this.textLabel = "Directeur partant *";
    }

    render() {
        return html`
			<subtitle-field label="${this.title}"></subtitle-field>
			<row-wrapper>
				<select-from-api label="Qualité *" api-url="${window.APP_URL.api.directorType}" required value="0" null-option-text="Choisir une nature" null-option-value="0" name="id_director_type"></select-from-api>
			</row-wrapper>
            <row-with-tooltip tooltip-text="Si personne physique, indiquer la civilité (M./Mme/Melle), le prénom et le nom. Si société, indiquer la dénomination sociale.">
                <text-field label="${this.textLabel}" required name="director_parting"></text-field>
            </row-with-tooltip>
        `;
    }
	
	isTransient (){
		return false;
	}
}

customElements.define("director-parting-field", DirectorPartingField);
